'use client';
export default function myImageLoader({ src }) {
    return src;
}
